import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../contexts/AuthContext';
import './Diplomacy.css';

const Diplomacy = () => {
  const [diplomacy, setDiplomacy] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ serverName: '', qqGroup: '' });
  const [selectedFile, setSelectedFile] = useState(null);
  const { user } = useContext(AuthContext);

  const fetchDiplomacy = async () => {
    try {
      const res = await axios.get('/api/diplomacy');
      setDiplomacy(res.data);
    } catch (err) {
      console.error('获取外交记录失败:', err);
    }
  };

  useEffect(() => {
    fetchDiplomacy();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      data.append('serverName', formData.serverName);
      data.append('qqGroup', formData.qqGroup);
      if (selectedFile) {
        data.append('serverLogo', selectedFile);
      }

      await axios.post('/diplomacy', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      setFormData({ serverName: '', qqGroup: '' });
      setSelectedFile(null);
      setShowForm(false);
      fetchDiplomacy();
    } catch (err) {
      console.error('添加失败:', err);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('确定要删除这条外交记录吗？')) {
      try {
        await axios.delete(`/diplomacy/${id}`);
        fetchDiplomacy();
      } catch (err) {
        console.error('删除失败:', err);
      }
    }
  };

  const copyQQGroup = (qqGroup) => {
    navigator.clipboard.writeText(qqGroup);
    alert('QQ群号已复制！');
  };

  return (
    <div className="diplomacy">
      <h1>外交</h1>
      {user && (user.permission === '腐竹' || user.permission === '管理') && (
        <div className="admin-controls">
          <button onClick={() => setShowForm(!showForm)} className="btn-primary">
            {showForm ? '取消' : '添加外交'}
          </button>
        </div>
      )}

      {showForm && (
        <form onSubmit={handleSubmit} className="diplomacy-form">
          <input
            type="text"
            placeholder="服务器名称"
            value={formData.serverName}
            onChange={(e) => setFormData({ ...formData, serverName: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="QQ群号"
            value={formData.qqGroup}
            onChange={(e) => setFormData({ ...formData, qqGroup: e.target.value })}
            required
          />
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setSelectedFile(e.target.files[0])}
          />
          <button type="submit" className="btn-primary">添加</button>
        </form>
      )}

      <div className="diplomacy-grid">
        {diplomacy.map((item) => (
          <div key={item._id} className="diplomacy-card">
            <img src={`https://longtengrailway.top${item.serverLogo}`} alt={item.serverName} className="server-logo" />
            <h3>{item.serverName}</h3>
            <div className="qq-group">
              <span>QQ群: {item.qqGroup}</span>
              <button onClick={() => copyQQGroup(item.qqGroup)} className="copy-btn">复制</button>
            </div>
            {user && (user.permission === '腐竹' || user.permission === '管理') && (
              <button onClick={() => handleDelete(item._id)} className="btn-delete">删除</button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Diplomacy;
